var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-23.14%",
    y1: "49.998%",
    x2: "180.546%",
    y2: "49.998%",
    id: "pdf_svg__svg-4068136840a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00756A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04FCF0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-20.896%",
    y1: "50%",
    x2: "65.659%",
    y2: "35.618%",
    id: "pdf_svg__svg-4068136840b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68616",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE2A1E",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0A1.88 1.88 0 003.75 1.875v26.25A1.88 1.88 0 005.625 30h18.75a1.88 1.88 0 001.875-1.875V7.5L18.75 0H5.625z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 7.5h5.625L18.75 0v5.625A1.88 1.88 0 0020.625 7.5z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M26.25 13.125L20.625 7.5h5.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24.375a.94.94 0 01-.938.938H.938A.94.94 0 010 24.375V15a.94.94 0 01.938-.938h20.625A.94.94 0 0122.5 15v9.375z",
    fill: "url(#pdf_svg__svg-4068136840a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.087 17.763c0-.248.195-.518.509-.518h1.731c.975 0 1.853.653 1.853 1.903 0 1.185-.878 1.845-1.853 1.845H5.076v.99c0 .33-.21.517-.48.517a.505.505 0 01-.51-.517v-4.22zm.989.426v1.868h1.251c.503 0 .9-.444.9-.909 0-.524-.397-.959-.9-.959H5.076zM9.648 22.5c-.248 0-.518-.135-.518-.464v-4.258c0-.27.27-.465.518-.465h1.716c3.426 0 3.351 5.187.068 5.187H9.648zm.472-4.272v3.358h1.244c2.024 0 2.114-3.358 0-3.358H10.12zM15.93 18.288v1.191h1.912c.27 0 .54.27.54.532 0 .247-.27.45-.54.45H15.93v1.574c0 .262-.187.464-.45.464-.33 0-.53-.202-.53-.464v-4.258c0-.27.202-.465.53-.465h2.633c.33 0 .525.196.525.465 0 .24-.195.51-.525.51H15.93z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.563 25.313H3.75v.937h17.813a.94.94 0 00.937-.938v-.937a.94.94 0 01-.938.938z",
    fill: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.625 0A1.88 1.88 0 003.75 1.875v26.25A1.88 1.88 0 005.625 30h18.75a1.88 1.88 0 001.875-1.875V7.5L18.75 0H5.625z",
    fill: "#E2E5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.625 7.5h5.625L18.75 0v5.625A1.88 1.88 0 0020.625 7.5z",
    fill: "#B0B7BD"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M26.25 13.125L20.625 7.5h5.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 24.375a.94.94 0 01-.938.938H.938A.94.94 0 010 24.375V15a.94.94 0 01.938-.938h20.625A.94.94 0 0122.5 15v9.375z",
    fill: "url(#pdf_svg__svg-4068136840b)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.087 17.763c0-.248.195-.518.509-.518h1.731c.975 0 1.853.653 1.853 1.903 0 1.185-.878 1.845-1.853 1.845H5.076v.99c0 .33-.21.517-.48.517a.505.505 0 01-.51-.517v-4.22zm.989.426v1.868h1.251c.503 0 .9-.444.9-.909 0-.524-.397-.959-.9-.959H5.076zM9.648 22.5c-.248 0-.518-.135-.518-.464v-4.258c0-.27.27-.465.518-.465h1.716c3.426 0 3.351 5.187.068 5.187H9.648zm.472-4.272v3.358h1.244c2.024 0 2.114-3.358 0-3.358H10.12zM15.93 18.288v1.191h1.912c.27 0 .54.27.54.532 0 .247-.27.45-.54.45H15.93v1.574c0 .262-.187.464-.45.464-.33 0-.53-.202-.53-.464v-4.258c0-.27.202-.465.53-.465h2.633c.33 0 .525.196.525.465 0 .24-.195.51-.525.51H15.93z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.563 25.313H3.75v.937h17.813a.94.94 0 00.937-.938v-.937a.94.94 0 01-.938.938z",
    fill: "#CAD1D8"
  })))));
}

export default SvgPdf;